import {
  Footer as SharedFooter,
  type FooterProps as SharedFooterProps,
} from '@instabox/consumer-web-shared'

import useAnalytics from '../../hooks/useAnalytics'

export type FooterProps = Omit<SharedFooterProps, 'onDownloadAppClick'>

export function Footer(props: FooterProps) {
  const sendAnalyticsEvent = useAnalytics()

  const onDownloadAppClick = () => sendAnalyticsEvent('try_instabox_app')

  return <SharedFooter {...props} onDownloadAppClick={onDownloadAppClick} />
}
